import type { AuthPermissionUser } from '../../services/authPermissions';

const CUSTOMER_ORDER_EDIT_ROLES = ['ADMIN', 'OPERATIONS', 'ORDER_STAFF', 'TESTER'];
const CUSTOMER_ORDER_OPERATION_ROLES = ['ADMIN', 'OPERATIONS'];

export function isCustomerOrderTesterMode(user: AuthPermissionUser | null | undefined): boolean {
  return user?.role === 'TESTER';
}

export function canCreateCustomerOrders(user: AuthPermissionUser | null | undefined): boolean {
  return CUSTOMER_ORDER_EDIT_ROLES.includes(user?.role || '');
}

export function canEditCustomerOrderDetails(user: AuthPermissionUser | null | undefined): boolean {
  return CUSTOMER_ORDER_EDIT_ROLES.includes(user?.role || '');
}

export function canChangeCustomerOrderStatus(user: AuthPermissionUser | null | undefined): boolean {
  return CUSTOMER_ORDER_EDIT_ROLES.includes(user?.role || '');
}

export function canManageCustomerOrderOperations(user: AuthPermissionUser | null | undefined): boolean {
  return CUSTOMER_ORDER_OPERATION_ROLES.includes(user?.role || '');
}

export function canDeleteCustomerOrders(user: AuthPermissionUser | null | undefined): boolean {
  return CUSTOMER_ORDER_OPERATION_ROLES.includes(user?.role || '');
}

export function canEditCustomerOrderDocumentFields(user: AuthPermissionUser | null | undefined): boolean {
  return CUSTOMER_ORDER_OPERATION_ROLES.includes(user?.role || '');
}

export function canEditCustomerOrderProducts(user: AuthPermissionUser | null | undefined): boolean {
  return CUSTOMER_ORDER_OPERATION_ROLES.includes(user?.role || '');
}

export function canManageCustomerOrderSupplierLinks(user: AuthPermissionUser | null | undefined): boolean {
  return CUSTOMER_ORDER_OPERATION_ROLES.includes(user?.role || '');
}

export function canManageOrderNotificationAssignments(user: AuthPermissionUser | null | undefined): boolean {
  return user?.role === 'ADMIN';
}

export function canDeleteCustomerOrderTransportLink(user: AuthPermissionUser | null | undefined): boolean {
  return user?.role === 'ADMIN';
}

export function canCreatePartialSettlement(user: AuthPermissionUser | null | undefined): boolean {
  return user?.role === 'ADMIN' || user?.role === 'OPERATIONS';
}

export function canEnterSettlementFinancials(user: AuthPermissionUser | null | undefined): boolean {
  return user?.role === 'ADMIN';
}

export function canUseOperationalSettlement(user: AuthPermissionUser | null | undefined): boolean {
  return user?.role === 'OPERATIONS';
}

export function canSettleCustomerOrder(user: AuthPermissionUser | null | undefined): boolean {
  return canCreatePartialSettlement(user);
}

export function canCloseCustomerOrderSettlement(user: AuthPermissionUser | null | undefined): boolean {
  return user?.role === 'ADMIN';
}
